export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10751.a686a69b.jpg";